import * as React from "react";
import { useRef, useState } from "react";
import type { ComponentProps } from "widgets/BaseComponent";
import _ from "lodash";
import "./index.css";
import styled from "styled-components";
import MapWidget from "@byk/pages/components/MapWidget";
import { parseWidgetData, strToJson } from "@byk/utils/Utils";

const ContainerWrapper = styled.div<{
}>`
  height:'300px';
`;

const AmapViewWidget = (props: any) => {
  const {
    value,
    onChange,
    isSearch,
    dragEnable,
    zoomEnable,
    zoomLevel,
    currentData,
    securityJsKey,
    securityJsCode,
    isShowCard,
    borderColor,
    borderWidth,
    borderRadius,
    boxShadow,
    centerLnglat,
    rotation,
    pitch,
    viewMode,
    mapStyle,
    features,
    isSetCenter
  } = props;

  const _value=parseWidgetData(value||currentData);
  const chooseMapRef = useRef(null);
  const onItemClick = (v: any) => {
    onChange && onChange(v);
  }

  return (
    <>
      <ContainerWrapper className="z-AmapViewWidget-ContainerWrapper" style={{ height: "inherit",
       border: `${borderWidth}px solid ${borderColor||"#bcb3b3"}`,
       boxShadow:boxShadow,
        borderRadius: borderRadius 
        }} {...props}>
        <MapWidget ref={chooseMapRef} callback={onItemClick} mode={"view"} defaultLngLat={_value}
          currentData={_value} securityJsKey={securityJsKey} securityJsCode={securityJsCode}
          centerLnglat={centerLnglat}
          isShowCard={isShowCard} dragEnable={dragEnable} zoomLevel={zoomLevel} zoomEnable={zoomEnable} isSearch={isSearch} 
          borderColor={borderColor}
          borderWidth={borderWidth}
          borderRadius={borderRadius}
          rotation={rotation}
          pitch={pitch}
          viewMode={viewMode}
          boxShadow={boxShadow}
          mapStyle={mapStyle}
          features={features}
          isSetCenter={isSetCenter}
          ></MapWidget>
      </ContainerWrapper>
    </>
  )
};

class AmapComponent extends React.Component<AmapComponentProps> {
  constructor(props: AmapComponentProps) {
    super(props);
  }

  render() {
    return <AmapViewWidget {...this.props} />;
  }
}

export interface AmapComponentProps extends ComponentProps {
  onChange?: () => void,
}

export default AmapComponent;
